module.exports = __webpack_public_path__ + "img/neurone-search2.d75024ad.gif";